import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateToLocale'
})
export class DateToLocalePipe implements PipeTransform {

  transform(date: string, isDateTime: boolean): string {

    if (date) {
      const newDate = new Date(date);
      if (isDateTime) {
        return newDate.toLocaleDateString() + ' ' + newDate.toLocaleTimeString();
      }
      else {
        return newDate.toLocaleDateString();
      }
      
    }
    else {
      return 'N/A';
    }
  }

}
